import React from 'react'
import { joinClasses, makeClasses } from '@utils/styles'
import Breakpoints from '@utils/breakpoints'
import { Colors } from '@utils/css-variables'
import Loader from '../loader'

type classes = {
	container: string
	bloc: string
	borderBottom: string
	noMarginBottom: string
	section: string
	sectionViewer: string
	loadingBlurBlock: string
	loadingText: string
}

export const classes: classes = makeClasses({
	container: {
		display: 'grid',
		flexWrap: 'wrap',
		marginRight: '-15px',
		marginLeft: '-15px',
		width: '100%',
		lineHeight: '1.62em',
		[Breakpoints.minWidth('lg')]: {
			gridTemplateColumns: '58.333333% 41.666667%'
		}
	},
	bloc: {
		background: Colors.white,
		padding: '40px',
		marginBottom: '30px'
	},
	borderBottom: {
		borderBottom: `1px solid ${Colors.lightGrey7} !important`
	},
	noMarginBottom: {
		marginBottom: '0px'
	},
	section: {
		position: 'relative',
		width: '100%',
		[Breakpoints.minWidth('lg')]: {
			paddingRight: '15px',
			paddingLeft: '15px'
		},
		[Breakpoints.maxWidth('md')]: {
			width: '100vw'
		}
	},
	sectionViewer: {
		margin: '50px',
		display: 'grid',
		[Breakpoints.maxWidth('md')]: {
			margin: '20px'
		}
	},
	/* Animation de shimmer */
	loadingBlurBlock: {
		position: 'relative',
		overflow: 'hidden',
		borderRadius: '5px',
		background: 'rgba(0, 0, 0, 0.05)',

		'&::before': {
			content: '""',
			position: 'absolute',
			inset: 0,
			backdropFilter: 'blur(6px)',
			//   -webkit-backdrop-filter: blur(6px);
			// background:
			// 'linear-gradient( 90deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.05) 100%)',
			background:
				'linear-gradient(90deg,rgba(255, 255, 255, 0.07) 0%,rgba(255, 255, 255, 0.25) 50%,rgba(255, 255, 255, 0.07) 100%)',
			animation:
				'shimmerMove 1.6s linear infinite, pulse 2s ease-in-out infinite',
			opacity: 1
		}
	},
	loadingText: {
		'& div div': {
			zIndex: '999'
		}
	}
})

const RequestLoader = () => {
	return (
		<div className={classes.sectionViewer}>
			<div className={classes.container}>
				{/* Left Section - Basic Informations + History */}
				<div className={classes.section}>
					<div
						className={joinClasses([classes.bloc, classes.loadingBlurBlock])}
						style={{ minHeight: '330px' }}
					>
						<div className={classes.loadingText}>
							<Loader text={'Chargement en cours...'} />
						</div>
					</div>
				</div>
				{/* Right Section - Payment + Summary + Attachments + Consent */}
				<div className={classes.section}>
					<div
						className={joinClasses([classes.bloc, classes.loadingBlurBlock])}
						style={{ minHeight: '150px' }}
					></div>
					<div
						className={joinClasses([classes.bloc, classes.loadingBlurBlock])}
						style={{ minHeight: '150px' }}
					></div>
				</div>
			</div>
		</div>
	)
}

export default RequestLoader
